import React from "react";
import { NavLink, useNavigate } from 'react-router-dom';
import './Sidebar.css';
import SecureLS from 'secure-ls';

const Sidebar = () => {
    const navigate = useNavigate();
    const ls = new SecureLS({encodingType: 'aes'})

    const handleLogout = () => {
        console.log('User logged out');
        ls.remove('jwtToken')
        navigate('/auth')
    }

    return (
        <div className="sidebar">
            <h3>Autonomio Admin Portal</h3>
            <ul>
                <li>
                    <NavLink to="/home/dashboard" activeClassName="active">Dashboard</NavLink>
                </li>
                <li>
                    <NavLink to="/home/ManageUsers" activeClassName="active">Benutzer Verwalten</NavLink>
                </li>
                <li>
                    <NavLink to="/home/ManageLicences" activeClassName="active">Lizenz Verwalten</NavLink>
                </li>
                <li>
                    <NavLink to="/home/MonitorLicenses" activeClassName="active">Lizenzen überwachen</NavLink>
                </li>
                <li>
                    <NavLink to="/home/UploadUpdate" activeClassName="active">Neue Version hochladen</NavLink>
                </li>
            </ul>
            <div className="logout-link">
                <button onClick={handleLogout} className="logout-button">Abmelden</button>
            </div>
        </div>
    );
}

export default Sidebar
